var addBootloader = (function () {
    const init = function () {
      $("#add-bootloader-button").on("click", function () {
        const viewModel = {
          Version: $("#Version").val(),
          Description: $("#Description").val(),
        };
  
        $.ajax({
          url: "/Bootloaders/Add",
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          if (data.success) {
            $.notificationSuccess(data.header, data.message);
            setTimeout(function () {
              document.location = "/Bootloaders/Index";
            }, reloadDelay);
          } else {
            $.notificationAlert(data.header, data.message);
          }
        });
      });
    };
  
    return {
      init: init,
    };
  })();
  